/**
 * Self-hosted studio IBL (replaces @react-three/drei preset="studio").
 * Source: HDRI Haven "Studio Small 03" via pmndrs/drei-assets (CC0).
 */
export const STUDIO_ENVIRONMENT_HDRI = '/hdri/studio_small_03_1k.hdr';
